import _ from 'lodash'
import { useCallback, useEffect, useState, VFC } from 'react'
import { Select, Button } from '@panwds/react-ui'
import SubscriptionService from '../../services/SubscriptionService'
import type { UserAndTsg, ReadonlyTsgTree } from '../../types'
import type { AppManifests } from '@sparky/framework'

type UserTsgs = UserAndTsg & { tsgs: ReadonlyTsgTree } & { apps: AppManifests }

type SupportAccount = {
  support_account_id: number;
  support_account_name: string;
  is_ela?: boolean
  ela?: { [key: string]: { url?: string } };
}
type MenuItem = {
  value: string;
  display: string;
  disabled: boolean;
  url: string;
}
const ElaDropDown: VFC<UserAndTsg & UserTsgs> = ({ user, tsg, tsgs, apps }) => {
  const [elaAccounts, setElaAccounts] = useState<any[]>([])
  useEffect(() => {
    SubscriptionService.supportAccounts.get({ tsg_id: tsg?.id, email: user.email }).then(async (data) => {
      // console.log('data', data)
      if (data.status === 200) {
        const supportAccounts: SupportAccount[] = data.data
        // console.log('supportAccounts', supportAccounts)
        const hasELAAccounts = supportAccounts.filter((account: SupportAccount) => account.is_ela)
        // console.log('hasELAAccounts', hasELAAccounts)
        if (hasELAAccounts) {
          const menuItems: any[] = []
          hasELAAccounts.forEach(account => {
            menuItems.push({
              'value': account.support_account_id,
              'display': account.support_account_name,
              'disabled': true
            })
            const elaAppNames = Object.keys(account.ela || {})
            elaAppNames?.forEach((appId: any) => {
              const appUrl = account.ela?.[appId]?.url
              if (!_.isEmpty(appUrl)) {
                const appname = apps.get(appId).display_name
                menuItems.push({
                  'value': appname,
                  'display': appname,
                  'disabled': false,
                  'url': appUrl
                })
              }
            })
          })
          //console.log('menuItems', menuItems)
          setElaAccounts(menuItems)
        }
      }
      else {
        setElaAccounts([])
      }
    }).catch((error) => {
      // console.log('error', error)
      setElaAccounts([])
    })
  }, [setElaAccounts, apps, tsg, user])
  const onClick = useCallback((url: string) => {
    // console.log('url', url)
    const base = new URL(url)
    const currentUrl = new URL(window.location.href)
    const { origin } = currentUrl
    // TODO: since we dont have `ela` route, replaceing ela/setup with new path
    const newpath = base.pathname?.replace('ela/setup', 'activation')
    //TODO: for now use current domain 'origin', in march its going to be new domain.
    const redirect_url = new URL(newpath, origin)
    //Since we need ela context, adding lic_ctx=ela in query param, since w/o route not sure what is otherway to maintain the context
    //redirect_url.searchParams.append('lic_ctx', 'ela')
    //const result = base.pathname.match(/\/([^\/]+)\/?$/)?.[1]
    // console.log('result', new URL(newpath,origin))
    window.location.href = redirect_url.href
  }, [])

  const btn = (
    <div className='tw-dark'>
      <Button
        appearance='tertiary-clear'
        isMenu
        fullWidth={false}
        size='md'
        addClassName='sparky-ela-support-btn'
        disabled={false}
      >ELA Activation</Button>
    </div>
  )
  return elaAccounts.length > 0 ? (
    <div className='sparky-hub-actions sparky-ela-support-wrapper'>
      <Select
        addClassName='cmm-modal-select'
        button={btn}
        items={elaAccounts}
        selectedItem={[]}
        fitToItemWidth
        fullWidth
        onChange={({ selectedItem }) => onClick((selectedItem as MenuItem)?.url)}
        formatOption={{
          view: (item) => {
            // console.log('item', item)
            const i = item as MenuItem
            if (i.disabled) {
              return (
                <div className="tw-flex tw-gap-2 tw-items-center ela-csp-account">
                  {`${i.display} (${i.value})`}
                </div>)
            }
            else {
              return (
                <div className="tw-flex tw-gap-2 tw-items-center  tw-pl-2">
                  {item.value}
                </div>
              )
            }
          },
        }}
      />
    </div>
  ) : null

}
export default ElaDropDown
